import styled from '@emotion/styled';
import React from 'react'
import { ModalContainer,UIcon,IconContainer, } from './CreateAdminUser';
import { ViewContainer } from './ViewClaim';

const ViewConfig = (props:any) => {
    const data = props.data;
  return (
    <ModalContainer>
        <div>
            <div>
                <div>
                <IconContainer><UIcon /></IconContainer>
                <span>Approval Configuration</span>
                </div>
            </div>
            <ViewContainer>
                <div></div>
                <div>
                    <span>Status</span>
                    <span className={'Active'}>{'Active'}</span>
                </div>
                <div>
                    <span>Approval Type</span>
                    <span>{data?.ApprovalTypName || 'Approval Type Name'}</span>
                </div>
                <div>
                    <span>Route</span>
                    <span>{data?.RouteName || "RouteName"}</span>
                </div>
                <div>
                    <span>Membership Type</span>
                    <span>{data?.Membership || 'Applicants'}</span>
                </div>
                <div>
                    <span>Role</span>
                    <span>{data?.RoleName || "RoleName"}</span>
                </div>
                <div>
                    <span>Role's Email</span>
                    <span>{data?.RoleEmails || 'RoleEmails'}</span>
                </div>
            </ViewContainer>
        </div>
    </ModalContainer>
  )
}

export default ViewConfig